/**
 * Notification Banner Component
 *
 * Displays a site-wide notification message at the top of every page, below the Navbar.
 * Slide-down entry / slide-up exit animation mirroring CookieBanner pattern.
 */

import { useState } from 'react';
import './NotificationBanner.css';

interface NotificationBannerProps {
  message: string;
  onDismiss: () => void;
}

export function NotificationBanner({ message, onDismiss }: NotificationBannerProps) {
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);

  const handleDismiss = () => {
    setIsAnimatingOut(true);
    setTimeout(() => {
      onDismiss();
    }, 300);
  };

  return (
    <div className="notification-banner-wrapper">
      <div
        className={`notification-banner ${isAnimatingOut ? 'slide-up' : 'slide-down'}`}
        role="status"
        aria-live="polite"
      >
        <span className="notification-banner-message">{message}</span>
        <button
          className="notification-banner-close"
          onClick={handleDismiss}
          aria-label="Dismiss notification"
        >
          ×
        </button>
      </div>
    </div>
  );
}
